'use client';

import { EvSalesResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: EvSalesResult;
  translations: ToolsTranslations['evSales'];
  marketCap: number;
  totalDebt: number;
  cash: number;
  sales: number;
  currency: string;
}

export default function ResultsDisplay({ result, translations, marketCap, totalDebt, cash, sales }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.ratio !== null ? `${result.ratio.toFixed(2)}${translations.ratioSuffix}` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>

      {result.isValid && result.ratio !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.marketCap}:</span><span className="font-medium">{marketCap.toLocaleString()} {translations.currencySuffix}</span></div>
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.totalDebt}:</span><span className="font-medium">{totalDebt.toLocaleString()} {translations.currencySuffix}</span></div>
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.cash}:</span><span className="font-medium">{cash.toLocaleString()} {translations.currencySuffix}</span></div>
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.sales}:</span><span className="font-medium">{sales.toLocaleString()} {translations.currencySuffix}</span></div>
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.enterpriseValue}:</span><span className="font-medium">{result.enterpriseValue?.toLocaleString()} {translations.currencySuffix}</span></div>
          </div>
        </div>
      )}
    </div>
  );
}


